import clearCommunicationComposition from 'actions/composition/lib/clear_communication_composition';
import CustomerView from 'models/location/customer_view';
import Err from 'models/err';
import SendThreadEmail from 'actions/composition/lib/send_thread_email';

// The first email of a side conversation is not a conversation message: the backend creates a task to
// hold the thread, so this skips SubmitComposition's conversation-item plumbing.
export default class SendThirdPartyEmail extends SendThreadEmail {
  postEmail(composed, email) {
    const { agentId, routingGroupId } = composed.assignee || {};
    return this.context.gateways.taskThreadStart.add(
      {},
      {
        customerId: this.currentCustomerId,
        channel: 'EMAIL',
        assignee: { agentId, routingGroupId },
        dueAt: composed.dueAt,
        email,
      }
    );
  }

  validate(composition, composed, recipients) {
    const errors = super.validate(composition, composed, recipients);
    if (!(composed.assignee && composed.assignee.routingGroupId)) {
      errors.push(
        new Err({
          attr: 'assignee',
          code: Err.Code.BLANK,
          detail: 'Choose who to assign the side conversation to',
        })
      );
    }
    return errors;
  }

  // Only touches the current-composition focus when it still points at the sent draft.
  closeSentComposition(composition) {
    const location = this.context.stores.currentLocation.get();
    if (location instanceof CustomerView && location.currentCompositionId === composition.id) {
      clearCommunicationComposition(this.context);
      return;
    }
    super.closeSentComposition(composition);
  }
}
